/**
 * @param dashboardCtx
 * @param span
 * @returns void
 */
export function setDashboardTimespan(dashboardCtx: LiveDashboardContextValue, span: string): void {
    if (!dashboardCtx) {
        return
    }

    if (
        typeof dashboardCtx.actions.setTimespan === 'function' &&
        typeof dashboardCtx.getWidgetStateForIndex === 'function'
    ) {
        dashboardCtx.actions.setTimespan(span, undefined, true)
    }
}
